import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentCheckmark = React.forwardRef<
  Svg,
  { fillColor?: string } & SvgProps
>(({ fillColor = '#212121', ...props }, ref) => (
  <Svg
    ref={ref}
    width={24}
    height={24}
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <Path
      d='M4.53 12.97a.75.75 0 00-1.06 1.06l4.5 4.5a.75.75 0 001.06 0l11-11a.75.75 0 00-1.06-1.06L8.5 16.94l-3.97-3.97z'
      fill={fillColor}
    />
  </Svg>
))
FluentCheckmark.displayName = 'FluentCheckmark'

export default FluentCheckmark
